import { useMemo } from "react";

import { hubModuleAllowsAdminSettings } from "@/lib/subapp-access";
import { useIntegratorMe } from "@/lib/me-query";

/**
 * Hub module administrator tier for that module (hub settings and similar). False while `/api/me` is loading.
 */
export function useHubModuleAdmin(appKey: string): boolean {
  const query = useIntegratorMe();
  return useMemo(() => hubModuleAllowsAdminSettings(query.data, appKey), [query.data, appKey]);
}
